import { Reducer } from 'redux';

import * as types from './api.types';
import * as constants from './api.constants';

const initialRequestState: types.IApiRequestState = {
  inProgress: false,
  error: null,
};

const initialState: types.IApiState = {
  getChart: initialRequestState,
  listChartVersions: initialRequestState,
  publishChartVersion: initialRequestState,
  publishDraftChart: initialRequestState,
  createEmptyDraft: initialRequestState,
  createDraftFromVersion: initialRequestState,
  deleteChart: initialRequestState,
  getAnnualsApi: initialRequestState,
  createAnnualApi: initialRequestState,
  updateAnnualApi: initialRequestState,
  deleteAnnualApi: initialRequestState,
  deleteUserGroup: initialRequestState,
  fetchLiveSessions: initialRequestState,
  self: initialRequestState,
  login: initialRequestState,
  oauthAuthorize: initialRequestState,
  searchMeetings: initialRequestState,
  getMeetingsSimple: initialRequestState,
  getMeetingsSimpleAdmin: initialRequestState,
  createMeetingSimple: initialRequestState,
  createMeetingFromApi: initialRequestState,
  updateMeetingSimple: initialRequestState,
  updateMeetingParticipants: initialRequestState,
  deleteMeeting: initialRequestState,
  finishMeetingSession: initialRequestState,
  joinMeeting: initialRequestState,
  setFolderForMeeting: initialRequestState,
  updateSession: initialRequestState,
  deleteSession: initialRequestState,
  saveEmail: initialRequestState,
  signUpUser: initialRequestState,
  searchUsers: initialRequestState,
  createUser: initialRequestState,
  updateUser: initialRequestState,
  updateUserEmail: initialRequestState,
  deleteUser: initialRequestState,
  enableUser: initialRequestState,
  checkUserExistence: initialRequestState,
  searchTasks: initialRequestState,
  getMyTasks: initialRequestState,
  searchAgendaItemApi: initialRequestState,
  getAgendaItemsApi: initialRequestState,
  saveAgendaItemsApi: initialRequestState,
  nextSessions: initialRequestState,
  lastAndNextSessions: initialRequestState,
  createScoreApi: initialRequestState,
  scoreBoard: initialRequestState,
  createScoreboard: initialRequestState,
  updateScoreboard: initialRequestState,
  updateScoreApi: initialRequestState,
  updateScoresBulkApi: initialRequestState,
  deleteScoreApi: initialRequestState,
  fetchKpisApi: initialRequestState,
  saveScoreOrderApi: initialRequestState,
  createTaskApi: initialRequestState,
  updateTaskApi: initialRequestState,
  deleteTaskApi: initialRequestState,
  getSharedTaskApi: initialRequestState,
  addTaskAttachment: initialRequestState,
  getWatchers: initialRequestState,
  addWatcher: initialRequestState,
  deleteWatcher: initialRequestState,
  getConclusions: initialRequestState,
  saveConclusion: initialRequestState,
  deleteConclusion: initialRequestState,
  searchNotifications: initialRequestState,
  updateNotification: initialRequestState,
  updateNotifications: initialRequestState,
  sendMessageToMeetingMembers: initialRequestState,
  searchTemplates: initialRequestState,
  createTemplate: initialRequestState,
  createSection: initialRequestState,
  updateSection: initialRequestState,
  deleteSection: initialRequestState,
  getMyCalendars: initialRequestState,
  getEvents: initialRequestState,
  getNodes: initialRequestState,
  createNode: initialRequestState,
  updateNode: initialRequestState,
  updateNodesPositions: initialRequestState,
  deleteNode: initialRequestState,
  getBoards: initialRequestState,
  createBoard: initialRequestState,
  updateBoard: initialRequestState,
  deleteBoard: initialRequestState,
  saveBoardOrderApi: initialRequestState,
  getBoardLists: initialRequestState,
  createBoardList: initialRequestState,
  updateBoardList: initialRequestState,
  deleteBoardList: initialRequestState,
  saveTaskOrder: initialRequestState,
  updateTaskOrder: initialRequestState,
  saveBoardListOrder: initialRequestState,
  getLabels: initialRequestState,
  createLabel: initialRequestState,
  updateLabel: initialRequestState,
  deleteLabel: initialRequestState,
  getCheckLists: initialRequestState,
  createCheckList: initialRequestState,
  updateCheckList: initialRequestState,
  deleteCheckList: initialRequestState,
  createChecklistItem: initialRequestState,
  updateChecklistItem: initialRequestState,
  deleteChecklistItem: initialRequestState,
  getActivities: initialRequestState,
  createActivity: initialRequestState,
  updateActivity: initialRequestState,
  deleteActivity: initialRequestState,
  moveTask: initialRequestState,
  copyTask: initialRequestState,
  moveStepAgendaApi: initialRequestState,
  getUserGroups: initialRequestState,
  createUserGroup: initialRequestState,
  searchPasswordGroups: initialRequestState,
  savePasswordGroup: initialRequestState,
  searchPasswords: initialRequestState,
  savePassword: initialRequestState,
  deletePassword: initialRequestState,
  getProjectTasks: initialRequestState,
  createProjectTask: initialRequestState,
  updateProjectTask: initialRequestState,
  deleteProjectTask: initialRequestState,
  getProjectTeams: initialRequestState,
  createProjectTeam: initialRequestState,
  updateProjectTeam: initialRequestState,
  deleteProjectTeam: initialRequestState,
  getProjects: initialRequestState,
  createProject: initialRequestState,
  updateProject: initialRequestState,
  deleteProject: initialRequestState,
  getProjectTimes: initialRequestState,
  getAccountProjects: initialRequestState,
  saveTimer: initialRequestState,
  getQuartals: initialRequestState,
  createQuartal: initialRequestState,
  updateQuartal: initialRequestState,
  deleteQuartal: initialRequestState,
  forgotPassword: initialRequestState,
  saveNewPassword: initialRequestState,
  getCompanyToolsCategories: initialRequestState,
  createCompanyToolsCategory: initialRequestState,
  updateCompanyToolsCategory: initialRequestState,
  deleteCompanyToolsCategory: initialRequestState,
  updateAnswer: initialRequestState,
  searchMeetingsInfo: initialRequestState,
  startMeetingSession: initialRequestState,
  searchSettings: initialRequestState,
  saveSettings: initialRequestState,
  resetSettingsColors: initialRequestState,
  integrateWrike: initialRequestState,
  fetchMeetingFolders: initialRequestState,
  createMeetingFolder: initialRequestState,
  updateMeetingFolder: initialRequestState,
  deleteMeetingFolder: initialRequestState,
  createFileFolder: initialRequestState,
  deleteFileFolder: initialRequestState,
  getFileFolders: initialRequestState,
  getFileFolder: initialRequestState,
  createFileFolderFile: initialRequestState,
  getMeetingTemplates: initialRequestState,
  fetchSessionTranscript: initialRequestState,
  fetchSessionTranscriptSummary: initialRequestState,
  getMeetingReports: initialRequestState,
  getUserReports: initialRequestState,
  updateMeetingShortcut: initialRequestState,
  getMeetingArchives: initialRequestState,
  getMeetingArchive: initialRequestState,
  updateUserGroup: initialRequestState,
  getUserSettings: initialRequestState,
  updateUserSettings: initialRequestState,
  changePasswordUserSettings: initialRequestState,
  syncUserWithSlack: initialRequestState,
  switchTenant: initialRequestState,
  searchUserTenants: initialRequestState,
  addUserToTenant: initialRequestState,
  createTenant: initialRequestState,
  getWrikeFolders: initialRequestState,
  syncWrikeFolders: initialRequestState,
  fetchWrikeFolderMeetings: initialRequestState,
  fetchTaskTypesByBoard: initialRequestState,
  removeWrikeIntegration: initialRequestState,
  getPersonalNotes: initialRequestState,
  createPersonalNote: initialRequestState,
  updatePersonalNote: initialRequestState,
  deletePersonalNote: initialRequestState,
  getCompanyContexts: initialRequestState,
  createCompanyContext: initialRequestState,
  updateCompanyContext: initialRequestState,
  deleteCompanyContext: initialRequestState,
  submitSupportRequest: initialRequestState,
  getSubscriptionAccess: initialRequestState,
  getSubscription: initialRequestState,
  startBilling: initialRequestState,
  deleteSubscription: initialRequestState,
  reactivateSubscription: initialRequestState,
  getBillingInfo: initialRequestState,
  saveBillingInfo: initialRequestState,
  createSetupIntent: initialRequestState,
  getPaymentMethods: initialRequestState,
  createPaymentMethod: initialRequestState,
  setDefaultPaymentMethod: initialRequestState,
  deletePaymentMethod: initialRequestState,
  getPayments: initialRequestState,
  getInvoices: initialRequestState,
  getInvoice: initialRequestState,
};

// exception to the rule, because of dynamic keys on state, it was easier to bundle everything into one reducer
// in general don't do this, create reducers per property
export const apiReducer: Reducer<types.IApiState, types.IApiAction> = (state = initialState, action) => {
  if (action.type === constants.STORE_API_IN_PROGRESS) {
    const key = (action as types.IStoreApiInProgress).payload;

    return {
      ...state,
      [key]: {
        ...state[key],
        inProgress: true,
      },
    };
  } else if (action.type === constants.CLEAR_API_IN_PROGRESS) {
    const key = (action as types.IClearApiInProgress).payload;

    return {
      ...state,
      [key]: {
        ...state[key],
        inProgress: false,
      },
    };
  } else if (action.type === constants.STORE_API_ERROR) {
    const { key, error } = (action as types.IStoreApiError).payload;

    return {
      ...state,
      [key]: {
        ...state[key],
        error,
      },
    };
  } else if (action.type === constants.CLEAR_API_ERROR) {
    const key = (action as types.IClearApiError).payload;

    return {
      ...state,
      [key]: {
        ...state[key],
        error: null,
      },
    };
  }

  return state;
};
